'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './paper-ballot-property-select.routes';

export class PaperBallotPropertySelectComponent {
  constructor(Auth, DTOptionsBuilder, dialogs, $uibModal, $window, $stateParams, VotingsService, $state, User,
              SettingsService, PropertyService, VoterGroupsService) {
    'ngInject';

    this.$state = $state;

    this.voteId = $stateParams.voteId;
    this.ballotId = $stateParams.ballotId;

    this.back = _ => $window.history.back();

    this.properties = [];
    this.selected = [];

    SettingsService.getByName({name: 'client'}, settings => {
      this.proxyVoteAllowed = settings.data.proxy && settings.data.proxy.canVote;
      this.useSuite = settings.data.useSuite;

      this.weightVisible = settings.data.weightVisible;
      this.hasBuildingNo = settings.data.buildingNoVisible;

      this.dtOptions = DTOptionsBuilder
        .newOptions()
        .withOption('order', (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc']);

      VotingsService.get({id: this.voteId}, vote => {
        this.vote = vote;

        let VG_DATA_METHOD = (this.useSuite) ? "getWithDataSuite" : "getWithData";
        VoterGroupsService[VG_DATA_METHOD]({id: this.vote.voterGroup._id}, vg => {

          this.properties = vg.properties;

          VotingsService.get({id: this.voteId}, vote => {
            this.vote = vote;
            this.ballot = this.vote.ballots.find(ballot => ballot._id = this.ballotId);

            this.properties.forEach(ppty => {
              let oVote = this.vote.votes.find(v => v.property == ppty._id && v.ballot == this.ballotId);
              ppty.voted = !!oVote;
            });

            this.dataInitComplete = true;
          });

        }, err => {
          console.log("Could not retrieve vote.")
        });
      }, err => {
        console.log("Could not retrieve users.")
      });

    });

  }

  castVotes() {
    this.$state.go('cast-vote-paper',{mode: 'paper', id: this.ballotId, voteId: this.voteId, properties: this.selected});
  }

  markAsSelected(property) {
    let availableProperty = this.properties.find(ppty => ppty.lot == property.lot && property.address == ppty.address);

    if (availableProperty) {
      if (this.selected.length && this.selected[0].eVoting.weight != availableProperty.eVoting.weight) {
        alert('You cannot select properties with different vote weights in one go.\nPlease select only properties that have the same weight.')
        return;
      }
      availableProperty.selected = true;
      this.selected.push(property);
    }
  }

  unmarkAsSelected(property) {
    let availableProperty = this.properties.find(ppty => ppty.lot == property.lot && property.address == ppty.address);

    if (availableProperty) {
      availableProperty.selected = false;
    }

    let selectedPropertyIndex = this.selected.findIndex(ppty => ppty.lot == property.lot && property.address == ppty.address);
    if (selectedPropertyIndex !== -1) {
      this.selected.splice(selectedPropertyIndex, 1);
    }
  }

}

export default angular.module('conduu.paperBallotPropertySelect', [uiRouter])
  .config(routes)
  .component('paperBallotPropertySelect', {
    template: require('./paper-ballot-property-select.html'),
    controller: PaperBallotPropertySelectComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/ballot/paper-ballot-property-select/paper-ballot-property-select.component.js